import { Component, Injector, Input, OnInit, SimpleChanges, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ModelField } from '@app/shared/interfaces/front-end-column';
import { BaseProductFieldComponent } from '../base-product-component/base-product-field.component';

@Component({
  selector: 'app-product-field-number',
  templateUrl: './product-field-number.component.html',
  styleUrls: ['./product-field-number.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductFieldNumberComponent),
      multi: true,
    },
  ],
})
export class ProductFieldNumberComponent
  extends BaseProductFieldComponent
  implements ControlValueAccessor
{
  value: number | null = null;
  constructor(injector: Injector) {
    super(injector);
    
    
  }

  onChange: any = (value: number) => {};
  onTouched: any = () => {};
  // writeValue(value: number): void {
  //   this.value = value;
  //   if (value != null) {
  //     this.value = +value;
  //   }
    
  //   this.onChange(this.value);
   
  // }

  writeValue(value: number): void {

    this.value = value !== null && value !== undefined ? value : null;

    this.onChange(this.value);
  }
  
  
  registerOnChange(fn: any): void {
    this.onChange = fn;
  
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;

  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
   
  }    


  
}
